// Utils
import {
    API_INVOICE_LIST_DETAILS,
    API_INVOICE_GENERATE_REPORT,
    API_INVOICE_GENERATE_INVOICE,
    API_UPDATE_INVOICE_PAYMENT_STATUS,
} from '../../../utils/API/apiUrls';
import { POST } from '../../../utils/fetchWrappers';

// API URLs

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import { downloadFile } from '../../../utils/helperMethods';
import * as invoiceActions from './invoice.actions';

// Constants
import {
    DOWNLOAD_INVOICE_FILE_REQUEST,
    FETCH_INVOICE_LIST_REQUEST,
    GENERATE_REPORT_INVOICE_REQUEST,
    UPDATE_INVOICE_PAYMENT_STATUS_REQUEST,
} from './invoice.constants';

// Libs
import { takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';

export function* fetchInvoiceDetails(actions) {
    yield put(invoiceActions.showLoader());
    try {
        const { payload } = actions;
        const res = {
            pageNo: payload.pageIndex,
            pageSize: payload.pageSize,
        };

        if (payload.merchantId) {
            res.merchantIds = [payload.merchantId];
        }

        if (payload.monthRange) {
            res.endDateTime = moment(payload.monthRange.upperDate, 'MM/YYYY')
                .endOf('month')
                .format('YYYY-MM-DD');

            res.startDateTime = moment(payload.monthRange.lowerDate, 'MM/YYYY')
                .startOf('month')
                .format('YYYY-MM-DD');
        }

        if (payload.paymentStatus) {
            res.paymentStatus = payload.paymentStatus;
        }

        if (payload.settlementType) {
            res.settlementType = payload.settlementType;
        }

        const { data } = yield call(POST, API_INVOICE_LIST_DETAILS, res);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(invoiceActions.fetchInvoiceDataSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                invoiceActions.fetchInvoiceDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(invoiceActions.fetchInvoiceDataError({ error: data }));
    }
    yield put(invoiceActions.hideLoader());
}

export function* generateInvoiceReportRequest(actions) {
    yield put(invoiceActions.showLoader());
    try {
        const payload = {
            ...actions.payload,
        };

        const request = {
            reportFileName: payload.reportFileName,
        };

        if (payload.monthRange) {
            request.endDateTime = moment(
                payload.monthRange.upperDate,
                'MM/YYYY'
            )
                .endOf('month')
                .format('YYYY-MM-DD');

            request.startDateTime = moment(
                payload.monthRange.lowerDate,
                'MM/YYYY'
            )
                .startOf('month')
                .format('YYYY-MM-DD');
        }

        if (payload.merchantId) {
            request.merchantIds = [payload.merchantId];
        }

        const { data } = yield call(POST, API_INVOICE_GENERATE_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                invoiceActions.generateInvoiceReportSuccess({
                    data,
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                invoiceActions.generateInvoiceReportError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(invoiceActions.generateInvoiceReportError({ error: data }));
    }
    yield put(invoiceActions.hideLoader());
}

export function* generateInvoice(actions) {
    yield put(invoiceActions.showLoader());
    try {
        const payload = {
            ...actions.payload,
        };

        const { data } = yield call(
            POST,
            API_INVOICE_GENERATE_INVOICE,
            payload
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(invoiceActions.generateInvoiceReportSuccess({ data }));
        } else if (data && data.errorMessage) {
            yield put(
                invoiceActions.generateInvoiceError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(invoiceActions.generateInvoiceError({ error: data }));
    }
    yield put(invoiceActions.hideLoader());
}

export function* updateInvoicePaymentStatus(actions) {
    try {
        const payload = {
            ...actions.payload,
        };

        const { data } = yield call(
            POST,
            API_UPDATE_INVOICE_PAYMENT_STATUS,
            payload
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                invoiceActions.updateInvoicePaymentStatusSuccess({ data })
            );
        } else if (data && data.errorMessage) {
            yield put(
                invoiceActions.updateInvoicePaymentStatusError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            invoiceActions.updateInvoicePaymentStatusError({ error: data })
        );
    }
}

export function* InvoiceSaga() {
    yield takeLatest(FETCH_INVOICE_LIST_REQUEST, fetchInvoiceDetails);
    yield takeLatest(
        DOWNLOAD_INVOICE_FILE_REQUEST,
        generateInvoiceReportRequest
    );
    yield takeLatest(GENERATE_REPORT_INVOICE_REQUEST, generateInvoice);
    yield takeLatest(
        UPDATE_INVOICE_PAYMENT_STATUS_REQUEST,
        updateInvoicePaymentStatus
    );
}
